import { BaseController } from './BaseController';
import { get } from '../Utils/helpers';

export default class CookieBannerController extends BaseController {
  id = 'CookieBannerController';

  init() {
    this.root = this.getRoot();
    setTimeout(() => {
      this.root.classList.add('cookie-banner-show');
    }, 250);
    this.btnOk = this.singleChildNode('btn-ok');

    this.btnOk.addEventListener('click', this.handleBtnOkClick);
  }

  handleBtnOkClick = () => {
    this.root.classList.remove('cookie-banner-show');
    setTimeout(() => {
      this.root.remove();
      get('/session/banner_accept/', this.acceptCallback);
    }, 350);
  };

  acceptCallback = () => {
    console.info('Cookies accepted by client');
  };
}
